import React from 'react'
const Error = () => {
  return <section className='section section-center text-center'>
    <h2>There was an error</h2>
    </section>
}

export default Error
